/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import template from './coupon-list-page.component.html';

import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../../common/controller/signal-admin-resource-list-state';
import {CouponApiService, CouponModel} from './coupon-api.service';
import {UIRouterModule} from '@uirouter/angular';
import {AppSharedModule} from '../../common/app-shared.module';
import {SignalAdminResourceListComponent} from '../../common/controller/signal-admin-resource-list.component';
import {CouponValidityComponent} from './coupon-validity-component';
import {CouponStatusComponent} from './coupon-status-component';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule, SignalAdminResourceListComponent, CouponValidityComponent, CouponStatusComponent],
  selector: 'adn-coupon-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CouponListPageComponent implements OnInit {
  readonly itemStateName = 'app.adm.coupons.coupon';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {label: 'couponCode', param: 'code'},
    {label: 'validity', param: '', sortable: false},
    {label: 'status', param: 'couponStatus'},
    {param: 'validFrom'},
    {param: 'validTo'},
    {label: 'discount', param: '', sortable: false}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<CouponModel>(
    inject(CouponApiService),
    {listId: 'fullCouponList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
